if (!customElements.get('uq-product-editor')) {
  customElements.define('uq-product-editor', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const root = this;
      const listen = (el, type, handler) => el?.addEventListener(type, handler, { signal });
      const variant = root.querySelector('[data-uq-variant]');
      const variantInput = root.querySelector('[data-uq-form-variant]');
      const quantityInput = root.querySelector('[data-uq-quantity]');
      const stageImage = root.querySelector('[data-uq-stage] img');
      const money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency', currency: window.Shopify?.currency?.active || 'EUR'
      });
      const totalFor = (quantity, price) => quantity === 2
        ? Number(root.dataset.bundleTwoPrice || price * 2)
        : quantity === 3 ? Number(root.dataset.bundleThreePrice || price * 3) : price;
      const imageFor = (src, alt) => {
        if (!stageImage || !src) return;
        stageImage.removeAttribute('srcset');
        stageImage.src = src;
        stageImage.alt = alt || '';
      };
      const refresh = () => {
        const option = variant?.selectedOptions[0];
        const price = Number(option?.dataset.price || root.dataset.initialPrice || 0);
        const compare = Number(option?.dataset.comparePrice || root.dataset.initialCompare || price);
        const available = option ? option.dataset.available === 'true' : root.dataset.initialAvailable === 'true';
        if (variantInput && variant) variantInput.value = variant.value;
        root.querySelectorAll('[data-uq-main-price], [data-uq-sticky-price]').forEach(el => el.textContent = money.format(price / 100));
        root.querySelectorAll('[data-uq-main-compare]').forEach(el => {
          el.hidden = compare <= price;
          el.textContent = money.format(compare / 100);
        });
        root.querySelectorAll('[data-uq-main-portion]').forEach(el => el.textContent = money.format(Math.round(price / 30) / 100) + ' ' + root.dataset.portionLabel);
        root.querySelectorAll('[data-uq-pack]').forEach(button => {
          const quantity = Number(button.dataset.uqPack || 1);
          const total = totalFor(quantity, price);
          const comparison = compare * quantity;
          const portions = Number(button.dataset.uqPackPortions || quantity * 30);
          button.dataset.uqPackTotal = String(total);
          const cost = button.querySelector('[data-uq-pack-price]');
          const previous = button.querySelector('[data-uq-pack-compare]');
          const portion = button.querySelector('[data-uq-pack-portion]');
          if (cost) cost.textContent = money.format(total / 100);
          if (previous) { previous.textContent = money.format(comparison / 100); previous.hidden = comparison <= total; }
          if (portion) portion.textContent = money.format(Math.round(total / portions) / 100) + ' ' + root.dataset.portionLabel;
        });
        const active = root.querySelector('[data-uq-pack].is-active');
        const quantity = Number(active?.dataset.uqPack || 1);
        if (quantityInput) quantityInput.value = String(quantity);
        const total = totalFor(quantity, price);
        const saving = root.querySelector('[data-uq-saving]');
        if (saving) {
          const difference = compare * quantity - total;
          saving.hidden = difference <= 0;
          if (difference > 0) saving.textContent = root.dataset.savingTemplate.replace('__AMOUNT__', money.format(difference / 100));
        }
        const newsletter = root.querySelector('[data-uq-newsletter-copy]');
        if (newsletter) {
          const reduced = Math.round(total * 0.85);
          newsletter.textContent = root.dataset.newsletterTemplate.replace('__TOTAL__', money.format(reduced / 100)).replace('__PORTION__', money.format(Math.round(reduced / (quantity * 30)) / 100));
        }
        root.querySelectorAll('.uq-product__add, [data-uq-sticky] button').forEach(button => {
          button.disabled = !available;
          const label = button.querySelector('[data-uq-add-label]');
          if (label) label.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
        });
      };
      root.querySelectorAll('[data-uq-thumb]').forEach(button => listen(button, 'click', () => {
        imageFor(button.dataset.image, button.dataset.alt);
        root.querySelectorAll('[data-uq-thumb]').forEach(el => el.classList.toggle('is-active', el === button));
      }));
      root.querySelectorAll('[data-uq-pack]').forEach(button => listen(button, 'click', () => {
        root.querySelectorAll('[data-uq-pack]').forEach(el => {
          el.classList.toggle('is-active', el === button);
          el.setAttribute('aria-pressed', String(el === button));
        });
        refresh();
      }));
      listen(variant, 'change', () => {
        refresh();
        const option = variant.selectedOptions[0];
        if (option?.dataset.image) imageFor(option.dataset.image, option.textContent);
        root.dispatchEvent(new CustomEvent('uq:variant-change', { bubbles: true, detail: { variantId: variant.value } }));
      });
      const subscription = root.querySelector('[data-uq-subscription]');
      const plan = root.querySelector('[data-uq-plan]');
      listen(subscription, 'change', () => { if (plan) plan.disabled = !subscription.checked; });
      const sticky = root.querySelector('[data-uq-sticky]');
      const main = root.querySelector('[data-uq-product-main]');
      if (sticky && main && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting; }, { threshold: 0.08 });
        this.observer.observe(main);
      }
      listen(document, 'shopify:block:select', event => {
        const target = event.target;
        if (!root.contains(target)) return;
        if (target.matches('[data-uq-thumb]')) target.click();
        target.querySelector('details')?.setAttribute('open', '');
        target.scrollIntoView({ block: 'center', behavior: 'instant' });
      });
      refresh();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
      this.observer = null;
    }
  });
}
